import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { ExternalTaskSource } from "../types";
export function useSyncExternalTask(source) {
  const $ = _c(9);
  const apiFetcher = useApiFetcher();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== apiFetcher || $[1] !== source) {
    t0 = taskId => apiFetcher(`/api/v1/tasks/external/${source}/sync/${taskId}`, {
      method: "POST"
    });
    $[0] = apiFetcher;
    $[1] = source;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== queryClient || $[4] !== source) {
    t1 = () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.tasks.all()
      });
      queryClient.invalidateQueries({
        queryKey: [...QUERY_KEYS.externalTasks(source)]
      });
    };
    $[3] = queryClient;
    $[4] = source;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return useMutation(t2);
}
export function useSyncAllExternalTasks(source) {
  const $ = _c(9);
  const apiFetcher = useApiFetcher();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== apiFetcher || $[1] !== source) {
    t0 = () => apiFetcher(`/api/v1/tasks/external/${source}/sync`, {
      method: "POST"
    });
    $[0] = apiFetcher;
    $[1] = source;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== queryClient || $[4] !== source) {
    t1 = () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.tasks.all()
      });
      queryClient.invalidateQueries({
        queryKey: [...QUERY_KEYS.externalTasks(source)]
      });
    };
    $[3] = queryClient;
    $[4] = source;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return useMutation(t2);
}